import React, { Component } from 'react';
import './shelf-featured-banner.css';
import Cover from "./cover.png";
import FoodStyling from "./food-styling.png";

export default class ShelfFeaturedBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  componentDidMount() {

  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    return (
      <div className="shelf-featured-banner" >
        <div className="shelf-featured-banner-cover" onClick={() => this.redirectTo("/content/uid/4735f757-ba08-f011-aaa7-002248e084a9/detail")}>
          <img className="shelf-featured-banner-cover-img" src={FoodStyling} />
        </div>
        {/* <div className="shelf-featured-banner-info">
          <div className="shelf-featured-banner-info-tag">Lançamento</div>
          <div className="shelf-featured-banner-info-title">Chá</div>
          <div className="shelf-featured-banner-info-description">da folha à xícara, como é explorado e apreciado pelo mundo</div>
          <div className="shelf-featured-banner-info-author">Krisi Smith</div>
        </div> */}
        <div className="shelf-featured-banner-info" onClick={() => this.redirectTo("/content/uid/4735f757-ba08-f011-aaa7-002248e084a9/detail")}>
          <div className="shelf-featured-banner-info-tag" role="heading" aria-level="2">Lançamento</div>
          <div className="shelf-featured-banner-info-title">Food Styling</div>
          <div className="shelf-featured-banner-info-description">Manual prático de produção gastronômica para foto e vídeo</div>
          <div className="shelf-featured-banner-info-author">Juliano Albano, João Martins Portelinha Neto</div>
        </div>
      </div>
    );
  }
}
